import type { AxiosApiResponsePromise } from "~/api/apiResponseTypes.ts";
import axiosApi from "~/api/axiosApi.ts";
import type {
	TeamUtilisationReport,
	YearlyUtilisationReport,
} from "~/modules/reports/api/utilisationReport/utilisationReportTypes.ts";

const utilisationBasePath = "reports/utilisation";


export function getYearlyUtilisationReport(year: string): AxiosApiResponsePromise<YearlyUtilisationReport> {
	return axiosApi.get(`${utilisationBasePath}/total/${year}`);
}

export function recalculateYearlyUtilisationReport(year: string): AxiosApiResponsePromise<YearlyUtilisationReport> {
	return axiosApi.post(`${utilisationBasePath}/total/${year}/recalculate`);
}

export function getTeamUtilisationReport(year: string): AxiosApiResponsePromise<TeamUtilisationReport> {
	return axiosApi.get(`${utilisationBasePath}/team/${year}`);
}

export function recalculateTeamUtilisationReport(year: string): AxiosApiResponsePromise<TeamUtilisationReport> {
	return axiosApi.post(`${utilisationBasePath}/team/${year}/recalculate`);
}
